export default __webpack_public_path__ + "static/media/non-gmo.b2838e50.svg";